import React, { memo } from "react";
import { DropdownDtpMatchingCellWrapper } from "./style";

const KTDropdownDtpMatchingCell = memo(({ title }) => {
  return <DropdownDtpMatchingCellWrapper>{title}</DropdownDtpMatchingCellWrapper>;
});

export default KTDropdownDtpMatchingCell;
